(function () {
    "use strict";
    angular.module('skillBuilderSaaS')
        .controller("EditExamAttemptCtrl", ["onlineExamsHistoryResource", "messageService", "attemptData", "$state", "$translate", "$scope", editExamAttemptCtrl]);
    function editExamAttemptCtrl(onlineExamsHistoryResource, messageService, attemptData, $state, $translate, $scope) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.attemptData = attemptData;
        vm.attemptData.result = attemptData.result === "Passed" ? 5 : 4;
        vm.save = function (isValid) {
            vm.saving = true;
            if (isValid) {
                onlineExamsHistoryResource.save({ person: $state.params.person, assignmentId: $state.params.assignmentId, activationNumber: $state.params.activationNumber, attemptNumber: vm.attemptData.number }, vm.attemptData, function () {
                    messageService.success("evaluations.onlineExams.attemptsHistory.editAttemptModal.success");
                    $scope.$close();
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
